<template>
  <div class="bg-white p-3">
    <div class="d-flex flex-column">
      <VInputWrapper
        name="content_nl"
        :label="multi_lang ? trans('core.nl') : ''"
        :errors="getErrors('content_nl')"
      >
        <VMarkdownEditor
          id="content_nl"
          v-model="content_nl"
        />
      </VInputWrapper>

      <template v-if="multi_lang">
        <VInputWrapper
          name="content_en"
          :label="trans('core.en')"
          :errors="getErrors('content_en')"
        >
          <VMarkdownEditor
            id="content_en"
            v-model="content_en"
          />
        </VInputWrapper>
      </template>

      <button
        type="button"
        class="btn btn-secondary float-right m-2"
        :disabled="isSaving"
        @click="toggleMultiLanguage"
      >
        {{ multi_lang ? trans('core.single_lang_object', { object: trans('core.message') }) : trans('core.multi_lang_object', { object: trans('core.message') }) }}
      </button>

      <button
        type="button"
        class="btn btn-primary float-right m-2"
        :disabled="isSaving"
        @click="save"
      >
        {{ trans('core.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import VMarkdownEditor from '@/employees/components/VMarkdownEditor.vue'

export default {
  name: 'SystemMessageContentEdit',
  components: { VMarkdownEditor },
  props: {
    value: {
      type: Object,
      required: false,
      default: () => {
        return {
          content_nl: '',
          content_en: '',
        }
      },
    },
    isSaving: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    errors: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data () {
    return {
      multi_lang: false,
      content_nl: '',
      content_en: '',
    }
  },

  watch: {
    content_nl: function (value) {
      this.updateValue()
    },
    content_en: function (value) {
      this.updateValue()
    },
  },

  mounted () {
    this.content_nl = this.value?.content_nl ?? ''
    this.content_en = this.value?.content_en ?? ''
    this.multi_lang = this.content_nl !== this.content_en
  },

  methods: {
    toggleMultiLanguage () {
      this.multi_lang = !this.multi_lang
      this.updateValue()
    },

    updateValue () {
      const valueEn = this.multi_lang ? this.content_en : this.content_nl
      this.$emit('input', {
        content_nl: this.content_nl,
        content_en: valueEn,
      })
    },

    getErrors (field) {
      const errors = this.errors[field] ?? []

      return errors.map(message => {
        return { message }
      })
    },

    save () {
      this.updateValue()
      this.$emit('save')
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-primary {
  background-color: #646B78 !important;
}
</style>
